import React from 'react';
import Avatar from '../common/Avatar';

const BigAvatar = props => <Avatar {...props} size={145} />;

export default BigAvatar;
